import {
    ASSIGNED_TO_TAB_REQUEST,
    ASSIGNED_TO_TAB_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    items: [],
    total: 0,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case ASSIGNED_TO_TAB_REQUEST:
            return { ...state, loading: true }

        case ASSIGNED_TO_TAB_RESULT:
            return { ...state, loading: false, items: action?.payload?.items || [], total: action?.payload?.total || 0 }

        case CLEAR_REDUX:
            return ["", "ASSIGNED_TO_TAB"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};